import axios from 'axios';
import { API_EXCEPTION_MSG, DEFAULT_SCROLL_INFO } from '../../Common';
import { API_RESULT_CD, BAD_REQUEST, CommonResult, FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, OK } from '../Common';

const endpoint = process.env.REACT_APP_API_URL;
const URL = `${endpoint}/cooperationInfo`;

export interface LinkedDataApiRequest {
  agencyCodes?: string[];
  fromDate?: string;
  toDate?: string;
  sortCodes: string[];
  businessTypes?: string[];
  size: number;
  from: number;
}

export interface CooperationInfoList {
  longNm: string;
  companyCfc: string;
  customerFullName: string | null;
  customerNumber: string;
  deleteFlg: string;
  receptionNumber: string | null;
  businessType: string;
  registrationCrewCode: string;
  agencyCd: string;
  acceptedDatetime: string;
  registrationCrewName: string | null;
  customerId: number;
}

export interface Summary {
  mobile: number;
  electric: number;
  internet: number;
}

export interface ScrollInfo {
  size: number;
  from: number;
}

export interface LinkedDataApiResponse {
  result: CommonResult;
  scrollInfo: ScrollInfo;
  summary: Summary;
  cooperationInfoList: CooperationInfoList[];
  hit: number;
}

export const summaryInfoInit: Summary = {
  mobile: 0,
  electric: 0,
  internet: 0,
};

/**
 * メール送信履歴一覧取得API
 * @param request リクエスト
 */
export async function getLinkedDataApi(request: LinkedDataApiRequest): Promise<LinkedDataApiResponse> {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const { data, status } = await axios.post<LinkedDataApiResponse>(URL, request, { headers });

    switch (status) {
      case OK.status:
        return data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(INTERNAL_SERVER_ERROR.message);
      case BAD_REQUEST.status:
        throw new Error(BAD_REQUEST.message);
      case NOT_FOUND.status:
        throw new Error(NOT_FOUND.message);
      case FORBIDDEN.status:
        throw new Error(FORBIDDEN.message);
      default:
        throw new Error('APIとの接続に失敗しました');
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
      summary: summaryInfoInit,
      cooperationInfoList: [],
      scrollInfo: {
        size: DEFAULT_SCROLL_INFO.SIZE,
        from: DEFAULT_SCROLL_INFO.FROM,
      },
      hit: 0,
    };
  }
}
